import type { FC, PropsWithChildren } from "react";
import { useEffect } from "react";
import { useAuth } from "../hooks/use-auth";
import { useNavigate } from "react-router-dom";
import { paths } from "../paths";

export const AuthGuard: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      const searchParams = new URLSearchParams({
        returnTo: globalThis.location.href,
      }).toString();
      navigate(`${paths.auth.login}?${searchParams}`, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <>{children}</>;
};
